import { render, staticRenderFns } from "./LayoutWithoutToolbar.vue?vue&type=template&id=ba5dfe6a"
import script from "./LayoutWithoutToolbar.vue?vue&type=script&lang=js"
export * from "./LayoutWithoutToolbar.vue?vue&type=script&lang=js"
import style0 from "./LayoutWithoutToolbar.vue?vue&type=style&index=0&id=ba5dfe6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports